import { render, staticRenderFns } from "./UpgradeNotice.vue?vue&type=template&id=45a461c3&scoped=true"
import script from "./UpgradeNotice.vue?vue&type=script&lang=js"
export * from "./UpgradeNotice.vue?vue&type=script&lang=js"
import style0 from "./UpgradeNotice.vue?vue&type=style&index=0&id=45a461c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a461c3",
  null
  
)

export default component.exports